/**
 * Detects the current environment (dev, staging, or prod)
 * @returns 'dev' | 'staging' | 'prod' | null
 */
export const getEnvironment = (): 'dev' | 'staging' | 'prod' | null => {
  if (typeof window === 'undefined') return null
  
  // Check for staging environment
  if (import.meta.env.VITE_ENVIRONMENT === 'staging' || 
      window.location.hostname.includes('staging') ||
      window.location.hostname.includes('staging.')) {
    return 'staging'
  }
  
  // Check for dev environment (localhost or dev domain)
  if (window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('dev') ||
      import.meta.env.MODE === 'development' ||
      import.meta.env.DEV) {
    return 'dev'
  }
  
  // Default to prod (or null if we can't determine)
  return 'prod'
}

